import { STATUS_TYPE } from '../../../enum';

export interface GetCountry {
  id: string;
}

export interface FindCountry {
  search?: string;
  limit?: number;
  skip?: number;
}

export interface CreatePatchCountry {
  id?: string;
  labelEn: string;
  labelAr: string;
  emoji: string;
  code: string;
  activeState: boolean;
}

export interface Country {
  id: string;
  labelEn: string;
  labelAr: string;
  emoji: string;
  code: string;
  activeState: boolean;
  createdBy: string;
  updatedBy: string;
  updatedAt: string;
  createdAt: string;
}

interface InitialState {
  data: Country[];
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: [],
  skip: 0,
  limit: 25,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};
